import { actionType } from "../actions/overtredelsegrupperActions";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];

const overtredelsegrupperReducer = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, actionType);

export default overtredelsegrupperReducer;
